import React from "react";
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Collapse,
    Grid,
    Card,
    CardContent,
    CardActions,
    Button,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Breadcrumbs,
    Link as MuiLink,
    Divider,
    Drawer,
    FormControlLabel,
    Switch,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import SettingsIcon from "@material-ui/icons/Settings";
import PolicyIcon from "@material-ui/icons/Policy";
import PageviewIcon from "@material-ui/icons/Pageview";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import SearchIcon from "@material-ui/icons/Search";
import BugReportIcon from "@material-ui/icons/BugReport";
import MapIcon from "@material-ui/icons/Map";
import TableChartIcon from "@material-ui/icons/TableChart";
import DescriptionIcon from "@material-ui/icons/Description";
import LabelIcon from "@material-ui/icons/Label";

import { connect } from "react-redux";

import Header from "../../common/Header";

const useStyles = makeStyles((theme) => ({
    listPaper: { background: "#fff", borderRadius: 8, border: "1px solid rgba(0,0,0,0.08)" },
    nested: { paddingLeft: theme.spacing(4) },
    nested2: { paddingLeft: theme.spacing(8) },
    gridItem: {
        width: "25%",
        [theme.breakpoints.down("md")]: { width: "50%" },
        [theme.breakpoints.down("xs")]: { width: "100%" },
    },
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column"
    },
    chips: {
        marginTop: theme.spacing(1),
        display: "flex",
        flexWrap: "wrap",
        gap: 6

    },
    cardChips: {
        color: "#fff",
        background: "darkblue",
        marginTop: theme.spacing(1),
    },
    breadcrumbLink: {
        cursor: "pointer"
    },
    video: {
        width: "100%",
        height: 0,
        paddingBottom: "56.25%",
        background: "#e9ecef",
        borderRadius: 8,
        position: "relative",
        marginTop: theme.spacing(1),
    },
    videoLabel: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        color: "#6c757d",
    },
    iconInline: {
        verticalAlign: "middle",
        marginRight: 6,
        opacity: 0.85
    },
    cardHeader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1.15rem',
        fontWeight: 'bold',
        width: '100%',
        textAlign: 'center',
        marginBottom: theme.spacing(2),
    },
    cardButton: {
        color: "#1A2A80",
        border: "1px solid #1A2A80",
        backgroundColor: "transparent",
        '&:hover': {
            color: "#fff",
            backgroundColor: "#1A2A80",
        },
        variant: "outlined",
    },
    video: {
        height: 0,
        paddingBottom: "56.25%",
        position: "relative",
    }
}));

// Node map to icon 
const iconFor = (node) => {
    const t = (node.node_type || "").toLowerCase();
    if (node.slug === "report-issues") return <BugReportIcon aria-hidden="true" />;
    if (node.slug === "site-guide") return <PageviewIcon aria-hidden="true" />;
    if (node.slug === "master-contacts") return <ImportContactsIcon aria-hidden="true" />;
    if (node.slug === "mobile-inspections") return <LibraryBooksIcon aria-hidden="true" />;
    if (node.slug === "searches-reports") return <SearchIcon aria-hidden="true" />;
    if (node.slug === "form-fields") return <DescriptionIcon aria-hidden="true" />;
    if (node.slug === "map") return <MapIcon aria-hidden="true" />;
    if (node.slug === "tables") return <TableChartIcon aria-hidden="true" />;
    if (t === "top") return <LibraryBooksIcon aria-hidden="true" />;
    if (t === "second") return <SettingsIcon aria-hidden="true" />;
    if (t === "third") return <LabelIcon aria-hidden="true" />;
    return <LibraryBooksIcon aria-hidden="true" />;
};


const TREE_ENDPOINT = "/api/help/tree";
const TOPICS_BY_TAGS_ENDPOINT = "/api/help/topics/by-tags";

function useFetchJSON(url) {
    const [state, setState] = React.useState({ data: null, loading: !!url, error: null });

    React.useEffect(() => {
        if (!url) {
            setState({ data: null, loading: false, error: null });
            return;
        }
        let cancelled = false;
        setState({ data: null, loading: true, error: null });

        fetch(url, { credentials: "same-origin" })
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })
            .then((json) => {
                if (!cancelled) setState({ data: json, loading: false, error: null });
            })
            .catch((err) => {
                if (!cancelled) setState({ data: null, loading: false, error: err });
            });

        return () => { cancelled = true; };
    }, [url]);

    return state;
}

export function HelpCenter({ user }) {
    const classes = useStyles();

    const [openTop, setOpenTop] = React.useState({});
    const [openSecond, setOpenSecond] = React.useState({});
    const [openThird, setOpenThird] = React.useState({});
    const [crumbs, setCrumbs] = React.useState(["Help Center"]);
    const [openTopT, setOpenTopT] = React.useState({});
    const [openSecondT, setOpenSecondT] = React.useState({});
    const [openThirdT, setOpenThirdT] = React.useState({});
    const [openTopic, setOpenTopic] = React.useState(null);
    const [showDrafts, setShowDrafts] = React.useState(false);
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const [selectedChips, setSelectedChips] = React.useState([]);
    const [visibleTopics, setVisibleTopics] = React.useState([]);
    const [helpCenterViews, setHelpCenterViews] = React.useState(null);
    const isHoustonEng = (email = "") => String(email).toLowerCase().endsWith("@houstoneng.com");
    const internal = isHoustonEng(user?.email);


    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null;
    }


    const catalogUrl = `${TREE_ENDPOINT}?include_drafts=${internal && showDrafts ? "1" : "0"}`;
    const { data: rawCatalog, loading, error } = useFetchJSON(catalogUrl);
    const templateUrl = internal ? `${TREE_ENDPOINT}?include_drafts=1` : null;
    const { data: rawTemplateCatalog } = useFetchJSON(templateUrl);

    const catalog = React.useMemo(
        () => (rawCatalog || []).filter((n) => n.slug !== "module-templates"),
        [rawCatalog]
    );
    const templateCatalog = React.useMemo(
        () => (rawTemplateCatalog || []).filter((n) => n.slug === "module-templates"),
        [rawTemplateCatalog]
    );

    React.useEffect(() => {
        setOpenTop({});
        setOpenSecond({});
        setOpenThird({});
        setOpenTopT({});
        setOpenSecondT({});
        setOpenThirdT({});
        setCrumbs(["Help Center"]);
    }, [showDrafts]);

    const allTopics = React.useMemo(() => {
        if (!catalog) return [];

        const out = [];

        const walk = (node, path = []) => {
            if (node.topics) node.topics.forEach((t) => out.push({ ...t, path }));
            (node.children || []).forEach((c) => walk(c, [...path, c.title]));
        };

        catalog.forEach((top) => walk(top, [top.title]));

        return out;
    }, [catalog]);


    const searchableTags = React.useMemo(() => {
        const set = new Set();

        allTopics.forEach((t) => (t.tags || []).forEach((tag) => set.add(tag)));

        return Array.from(set).sort();

    }, [allTopics]);


    const fetchTopicsByTags = React.useCallback((tags) => {
        if (!tags.length) { setVisibleTopics([]); return; }

        const url = `${TOPICS_BY_TAGS_ENDPOINT}?tags=${encodeURIComponent(tags.join(","))}&include_drafts=${internal && showDrafts ? "1" : "0"}`;

        fetch(url, { credentials: "same-origin" })
            .then((res) => { if (!res.ok) throw new Error(`HTTP ${res.status}`); return res.json(); })
            .then((json) => {
                setVisibleTopics(Array.isArray(json.results) ? json.results : []);
            })
            .catch((err) => console.error(err));
    }, [showDrafts]);


    React.useEffect(() => {
        fetchTopicsByTags(selectedChips);
    }, [selectedChips, fetchTopicsByTags]);


    const toggleDrawer = (open) => (event) => {
        if (event?.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) return;
        setDrawerOpen(open);
    };
    const handleChipClick = (tag) => {
        setSelectedChips((prev) => (prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]));
    };
    const resetTo = (index) => {
        if (index === 0) {
            setOpenTop({}); setOpenSecond({}); setOpenThird({}); setCrumbs(["Help Center"]);
        } else if (index === 1) {
            setOpenSecond({}); setOpenThird({}); setCrumbs((c) => c.slice(0, 2));
        } else if (index === 2) {
            setOpenThird({}); setCrumbs((c) => c.slice(0, 3));
        }
    };
    const toggleTop = (node) => {
        const key = node.slug || node.id || node.title;
        setOpenTop({ [key]: !openTop[key] });
        setOpenSecond({});
        setOpenThird({});
        setCrumbs(["Help Center", node.title]);
    };
    const toggleSecond = (topNode, node) => {
        const tk = topNode.slug || topNode.id || topNode.title;
        const nk = node.slug || node.id || node.title;
        setOpenSecond({ [tk]: { [nk]: !(openSecond[tk]?.[nk]) } });
        setOpenThird({});
        setCrumbs(["Help Center", topNode.title, node.title]);
    };
    const toggleThird = (secondNode, node) => {
        const sk = secondNode.slug || secondNode.id || secondNode.title;
        const nk = node.slug || node.id || node.title;
        setOpenThird({ [sk]: { [nk]: !(openThird[sk]?.[nk]) } });
        setCrumbs((prev) => ["Help Center", ...prev.slice(1, 3), node.title]);
    };

    const toggleTopT = (node) => {
        const key = node.slug || node.id || node.title;
        setOpenTopT({ [key]: !openTopT[key] });
        setOpenSecondT({});
        setOpenThirdT({});
    };
    const toggleSecondT = (topNode, node) => {
        const tk = topNode.slug || topNode.id || topNode.title;
        const nk = node.slug || node.id || node.title;
        setOpenSecondT({ [tk]: { [nk]: !(openSecondT[tk]?.[nk]) } });
        setOpenThirdT({});
    };
    const toggleThirdT = (secondNode, node) => {
        const sk = secondNode.slug || secondNode.id || secondNode.title;
        const nk = node.slug || node.id || node.title;
        setOpenThirdT({ [sk]: { [nk]: !(openThirdT[sk]?.[nk]) } });
    };


    React.useEffect(() => {
        let cancelled = false;

        const csrftoken = getCookie("csrftoken");

        fetch("/api/help/metrics/page-view/", {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": csrftoken || "",
                "X-Requested-With": "XMLHttpRequest",
            },
        })
            .then((res) => (res.ok ? res.json() : null))
            .then((json) => {
                if (cancelled) return;
                if (json?.internal) setHelpCenterViews(json.view_count);
            })
            .catch(() => { });

        return () => {
            cancelled = true;
        };
    }, []);


    const renderChips = () =>
        searchableTags.map((tag) => (
            <Chip
                key={tag}
                icon={<LabelIcon aria-hidden="true" style={{ color: selectedChips.includes(tag) ? "#fff" : undefined, opacity: 0.85 }} />}
                label={`#${tag}`}
                clickable
                aria-pressed={selectedChips.includes(tag)}
                onClick={() => handleChipClick(tag)}
                style={{
                    margin: "12px 8px",
                    padding: "8px 12px",
                    ...(selectedChips.includes(tag) && { backgroundColor: "#1A2A80", color: "#fff" }),
                }}
            />
        ));

    return (
        <>
            <Header />
            <Box p={4}>
                <br /> <br />
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography
                        variant="h2"
                        style={{
                            display: "block",
                            fontSize: "48px",
                            fontWeight: "400",

                        }}
                    >
                        Help Center
                    </Typography>

                    {internal && (
                        <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        color="primary"
                                        checked={showDrafts}
                                        onChange={(e) => setShowDrafts(e.target.checked)}
                                    />
                                }
                                label="Show drafts"
                            />

                            <Typography
                                variant="body2"
                            // color="textSecondary"
                            >
                                Views: {helpCenterViews == null ? "—" : helpCenterViews}
                            </Typography>
                        </Box>
                    )}

                    {/* { isHoustonEng(user?.email) && (
                        <Typography
                            variant="body2"
                            color="textSecondary"
                        >
                            Views: {helpCenterViews}
                        </Typography>
                    )} */}
                </Box>

                <Box
                    mb={3}
                    display="flex"
                    flexWrap="wrap"
                    justifyContent="center"
                    gap={8}
                >
                    <Button
                        onClick={toggleDrawer(true)}
                        style={{
                            width: "50%",
                            padding: "12px 16px",
                            borderRadius: 8
                        }}
                    >
                        <Typography
                            style={{
                                fontWeight: "bold",
                                color: "#1A2A80",
                                fontSize: 18,
                            }}
                            variant="h2"
                        >
                            Search by Keywords
                        </Typography>
                    </Button>

                    <Drawer
                        anchor="top"
                        open={drawerOpen}
                        onClose={toggleDrawer(false)}
                        keepMounted
                        aria-label="Keyword filter"
                    >
                        <Box
                            p={2}
                            role="presentation"
                        >
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                mb={1}
                            >
                                <Typography
                                    variant="h1"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 18
                                    }}
                                >
                                    Select keywords to filter help topics
                                </Typography>
                                <Box>

                                    <Button
                                        onClick={() => setSelectedChips([])}
                                        style={{
                                            marginRight: 8,
                                            width: 100
                                        }}
                                    >
                                        Clear
                                    </Button>

                                    <Button
                                        onClick={toggleDrawer(false)}
                                        style={{
                                            marginLeft: 8,
                                            width: 100
                                        }}
                                    >
                                        Done
                                    </Button>

                                </Box>
                            </Box>
                            <Divider />

                            <Box
                                mt={1}
                                display="flex"
                                flexWrap="wrap"
                            >
                                {renderChips()}
                            </Box>

                        </Box>
                    </Drawer>
                </Box>

                {selectedChips.length > 0 && (
                    <>
                        <Box
                            mt={2}
                            width="100%"
                            textAlign="center"
                        >
                            <Typography
                                variant="h3"
                                style={{
                                    fontSize: 23,
                                    fontFamily: 'Source Sans Pro, sans-serif',
                                    fontWeight: 400,
                                    lineHeight: 1.6
                                }}
                            >
                                Displaying selected tags:
                            </Typography>

                            <Box
                                mt={1}
                                display="flex"
                                justifyContent="center"
                                flexWrap="wrap"
                                gap={8}
                            >

                                {selectedChips.map((tag) => (
                                    <Chip
                                        key={tag}
                                        label={tag}
                                        onDelete={() => handleChipClick(tag)}
                                        color="primary"
                                        style={{
                                            margin: "12px 8px",
                                            padding: "8px 12px",
                                            backgroundColor: "#1A2A80",
                                        }}
                                    />
                                ))}

                            </Box>
                        </Box>

                        <Box
                            mt={4}
                        >
                            <Grid
                                container
                                spacing={2}
                                wrap="wrap"
                                justifyContent="space-evenly"
                            >
                                {visibleTopics.map((t) => (
                                    <Grid
                                        item
                                        key={t.id || t.title}
                                        className={classes.gridItem}
                                    >
                                        <Card
                                            className={classes.card}
                                            style={{
                                                borderRadius: 8,
                                                border: "1px solid rgba(0,0,0,0.08)",
                                                boxShadow: "none",
                                                background: "whitesmoke"
                                            }}
                                        >
                                            <CardContent>
                                                <Typography
                                                    variant="h1"
                                                    className={classes.cardHeader}
                                                >
                                                    {t.title}
                                                </Typography>
                                                <hr style={{ width: "100%", borderColor: "rgba(0,0,0,0.1)" }} />
                                                <div
                                                    className={classes.chips}
                                                >
                                                    {(t.tags || []).map((tag) => (
                                                        <Chip
                                                            key={tag}
                                                            size="small"
                                                            label={`#${tag}`}
                                                            className={classes.cardChips}
                                                        />
                                                    ))}
                                                </div>
                                            </CardContent>

                                            <CardActions>
                                                <Button
                                                    className={classes.cardButton}
                                                    onClick={() => setOpenTopic(t)}
                                                >
                                                    View Video/Documentation
                                                </Button>
                                            </CardActions>

                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </>
                )}

                <br />
                <br />

                <Breadcrumbs
                    aria-label="breadcrumb"
                    style={{
                        marginBottom: 16,
                        padding: 8,
                        background: "#f8f9fa",
                        borderRadius: 8
                    }}
                >

                    {crumbs.map((c, i) => (
                        <MuiLink
                            key={i}
                            color={i === crumbs.length - 1 ? "textPrimary" : "inherit"}
                            className={classes.breadcrumbLink}
                            role="button"
                            tabIndex={0}
                            onClick={() => resetTo(i)}
                            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") resetTo(i); }}
                            aria-current={i === crumbs.length - 1 ? "page" : undefined}
                        >
                            {c}
                        </MuiLink>
                    ))}

                </Breadcrumbs>

                {loading && <Typography role="status" aria-live="polite">Loading…</Typography>}
                {error && <Typography role="alert" color="error">Couldn't load help catalog. Double-check your Django URL /api/help/tree.</Typography>}
                {!loading && !error && (
                    <List
                        className={classes.listPaper}
                    >
                        {(catalog || []).map((top) => {
                            const topKey = top.slug || top.id || top.title;
                            const topOpen = !!openTop[topKey];
                            return (
                                <React.Fragment
                                    key={topKey}
                                >
                                    <ListItem
                                        button
                                        onClick={() => toggleTop(top)}
                                        aria-expanded={topOpen}
                                        style={{
                                            background: topOpen ? "#1A2A80" : "inherit",
                                            borderRadius: topOpen ? 8 : 0
                                        }}
                                    >
                                        <ListItemIcon
                                            style={{
                                                color: topOpen ? "#fff" : "inherit"
                                            }}
                                        >
                                            {iconFor(top)}
                                        </ListItemIcon>

                                        <ListItemText
                                            primary={top.title}
                                            primaryTypographyProps={{
                                                style: {
                                                    fontWeight: topOpen ? "bold" : "normal", color: topOpen ? "#fff" : "inherit",
                                                }
                                            }}
                                        />
                                        {topOpen
                                            ?
                                            <ExpandLess aria-hidden="true"
                                                style={{ color: "#fff" }}
                                            />
                                            :
                                            <ExpandMore aria-hidden="true" />
                                        }
                                    </ListItem>

                                    <Collapse
                                        in={topOpen}
                                        timeout="auto"
                                        unmountOnExit
                                    >
                                        <List
                                            disablePadding
                                        >
                                            {(top.children || []).map((second) => {
                                                const tk = topKey;
                                                const sk = second.slug || second.id || second.title;
                                                const secondOpen = !!(openSecond[tk]?.[sk]);

                                                return (
                                                    <React.Fragment
                                                        key={sk}
                                                    >
                                                        <ListItem
                                                            button
                                                            className={classes.nested}
                                                            onClick={() => toggleSecond(top, second)}
                                                            aria-expanded={secondOpen}
                                                            style={{
                                                                background: secondOpen ? "#3c55e6" : "rgba(26, 42, 128, 0.15)",
                                                                borderRadius: secondOpen ? 8 : 0,
                                                                marginTop: 2,
                                                            }}
                                                        >
                                                            <ListItemIcon
                                                                style={{
                                                                    color: secondOpen ? "#fff" : "inherit"
                                                                }}
                                                            >

                                                                {iconFor(second)}

                                                            </ListItemIcon>

                                                            <ListItemText
                                                                primary={second.title}
                                                                primaryTypographyProps={{
                                                                    style: { fontWeight: secondOpen ? "bold" : "normal", color: secondOpen ? "#fff" : "inherit" }
                                                                }}
                                                            />

                                                            {secondOpen
                                                                ?
                                                                <ExpandLess aria-hidden="true"
                                                                    style={{ color: "#fff" }}
                                                                />
                                                                :
                                                                <ExpandMore aria-hidden="true" />
                                                            }

                                                        </ListItem>

                                                        <Collapse
                                                            in={secondOpen}
                                                            timeout="auto"
                                                            unmountOnExit
                                                        >
                                                            <List
                                                                disablePadding
                                                            >
                                                                {(second.children || []).map((third) => {
                                                                    const skey = sk;
                                                                    const tk3 = third.slug || third.id || third.title;
                                                                    const thirdOpen = !!(openThird[skey]?.[tk3]);

                                                                    return (
                                                                        <React.Fragment
                                                                            key={tk3}
                                                                        >
                                                                            <ListItem
                                                                                button
                                                                                className={classes.nested2}
                                                                                onClick={() => toggleThird(second, third)}
                                                                                aria-expanded={thirdOpen}
                                                                                style={{
                                                                                    background: thirdOpen ? "#B2B0E8" : "whitesmoke",
                                                                                    borderRadius: thirdOpen ? 8 : 0,
                                                                                    marginTop: 2,
                                                                                }}
                                                                            >
                                                                                <ListItemIcon
                                                                                    style={{
                                                                                        color: thirdOpen ? "#fff" : "inherit"
                                                                                    }}
                                                                                >
                                                                                    {iconFor(third)}
                                                                                </ListItemIcon>

                                                                                <ListItemText
                                                                                    primary={third.title}
                                                                                    primaryTypographyProps={{
                                                                                        style: {
                                                                                            fontWeight: thirdOpen ? "bold" : "normal", color: thirdOpen ? "#fff" : "inherit"
                                                                                        }
                                                                                    }}
                                                                                />
                                                                                {thirdOpen ? <ExpandLess aria-hidden="true" style={{ color: "#fff" }} /> : <ExpandMore aria-hidden="true" />}
                                                                            </ListItem>

                                                                            <Collapse
                                                                                in={thirdOpen}
                                                                                timeout="auto"
                                                                                unmountOnExit
                                                                            >
                                                                                <Box
                                                                                    px={4}
                                                                                    pb={2}
                                                                                    pt={2}
                                                                                >
                                                                                    <Grid
                                                                                        container
                                                                                        spacing={2}
                                                                                        wrap="wrap"
                                                                                        justifyContent="space-evenly"
                                                                                    >

                                                                                        {(third.topics || []).map((t) => (
                                                                                            <Grid
                                                                                                item
                                                                                                key={t.id || t.title}
                                                                                                className={classes.gridItem}
                                                                                            >

                                                                                                <Card
                                                                                                    className={classes.card}
                                                                                                    style={{
                                                                                                        borderRadius: 8,
                                                                                                        border: "1px solid rgba(0,0,0,0.08)",
                                                                                                        boxShadow: "none",
                                                                                                        background: "whitesmoke",
                                                                                                    }}
                                                                                                >
                                                                                                    <CardContent>

                                                                                                        <Typography
                                                                                                            variant="subtitle1"
                                                                                                            className={classes.cardHeader}
                                                                                                        >
                                                                                                            {t.title}
                                                                                                        </Typography>
                                                                                                        <hr style={{ width: "100%", borderColor: "rgba(0,0,0,0.1)" }} />
                                                                                                        <div className={classes.chips}>
                                                                                                            {(t.tags || []).map((tag) => (
                                                                                                                <Chip
                                                                                                                    key={tag}
                                                                                                                    size="small"
                                                                                                                    label={`#${tag}`}
                                                                                                                    className={classes.cardChips}
                                                                                                                />
                                                                                                            ))}
                                                                                                        </div>

                                                                                                    </CardContent>

                                                                                                    <CardActions>
                                                                                                        <Button
                                                                                                            className={classes.cardButton}
                                                                                                            onClick={() => setOpenTopic({ ...t, path: [top.title, second.title, third.title] })}
                                                                                                        >
                                                                                                            View Video/Documentation
                                                                                                        </Button>
                                                                                                    </CardActions>
                                                                                                </Card>
                                                                                            </Grid>
                                                                                        ))}
                                                                                    </Grid>
                                                                                </Box>
                                                                            </Collapse>
                                                                        </React.Fragment>
                                                                    );
                                                                })}

                                                                {(second.topics || []).length > 0 && (
                                                                    <>
                                                                        <Divider />
                                                                        <Box
                                                                            px={4}
                                                                            pb={2}
                                                                            pt={2}
                                                                        >
                                                                            <Grid
                                                                                container
                                                                                spacing={2}
                                                                                wrap="wrap"
                                                                                justifyContent="space-evenly"
                                                                            >
                                                                                {(second.topics || []).map((t) => (
                                                                                    <Grid
                                                                                        item
                                                                                        key={t.id || t.title}
                                                                                        className={classes.gridItem}
                                                                                    >
                                                                                        <Card
                                                                                            className={classes.card}
                                                                                            style={{
                                                                                                borderRadius: 8,
                                                                                                border: "1px solid rgba(0,0,0,0.08)",
                                                                                                boxShadow: "none",
                                                                                                background: "whitesmoke",
                                                                                            }}
                                                                                        >
                                                                                            <CardContent>
                                                                                                <Typography
                                                                                                    variant="h3"
                                                                                                    className={classes.cardHeader}
                                                                                                >
                                                                                                    {t.title}
                                                                                                </Typography>
                                                                                                <hr style={{ width: "100%", borderColor: "rgba(0,0,0,0.1)" }} />
                                                                                                <div
                                                                                                    className={classes.chips}
                                                                                                >
                                                                                                    {(t.tags || []).map((tag) => (
                                                                                                        <Chip
                                                                                                            key={tag}
                                                                                                            size="small"
                                                                                                            label={`#${tag}`}
                                                                                                            className={classes.cardChips}
                                                                                                        />
                                                                                                    ))}
                                                                                                </div>
                                                                                            </CardContent>
                                                                                            <CardActions>
                                                                                                <Button
                                                                                                    className={classes.cardButton}
                                                                                                    onClick={() => setOpenTopic({ ...t, path: [top.title, second.title] })}
                                                                                                >
                                                                                                    View Video/Documentation
                                                                                                </Button>
                                                                                            </CardActions>
                                                                                        </Card>
                                                                                    </Grid>
                                                                                ))}
                                                                            </Grid>
                                                                        </Box>
                                                                    </>
                                                                )}
                                                            </List>
                                                        </Collapse>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </List>
                                    </Collapse>
                                    <Divider />
                                </React.Fragment>
                            );
                        })}
                    </List>
                )}

                {/* {internal && templateCatalog.length > 0 && ( */}
                <Box mt={4}>
                    <Typography
                        variant="h2"
                        style={{
                            fontWeight: "bold",
                            marginBottom: 12,
                            color: "#262626",
                            fontSize: 23,
                            fontFamily: 'Source Sans Pro, sans-serif',
                            lineHeight: 1.334,
                        }}
                    >
                        Module Templates
                    </Typography>
                    <List className={classes.listPaper}>
                        {templateCatalog.map((top) => {
                            const topKey = top.slug || top.id || top.title;
                            const topOpen = !!openTopT[topKey];
                            return (
                                <React.Fragment key={topKey}>
                                    <ListItem
                                        button
                                        onClick={() => toggleTopT(top)}
                                        aria-expanded={topOpen}
                                        style={{
                                            background: topOpen ? "#1A2A80" : "inherit",
                                            borderRadius: topOpen ? 8 : 0,
                                        }}
                                    >
                                        <ListItemIcon style={{ color: topOpen ? "#fff" : "inherit" }}>
                                            {iconFor(top)}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={top.title}
                                            primaryTypographyProps={{
                                                style: { fontWeight: topOpen ? "bold" : "normal", color: topOpen ? "#fff" : "inherit" },
                                            }}
                                        />
                                        {topOpen ? <ExpandLess aria-hidden="true" style={{ color: "#fff" }} /> : <ExpandMore aria-hidden="true" />}
                                    </ListItem>

                                    <Collapse in={topOpen} timeout="auto" unmountOnExit>
                                        <List disablePadding>
                                            {(top.children || []).map((second) => {
                                                const tk = topKey;
                                                const sk = second.slug || second.id || second.title;
                                                const secondOpen = !!(openSecondT[tk]?.[sk]);
                                                return (
                                                    <React.Fragment key={sk}>
                                                        <ListItem
                                                            button
                                                            className={classes.nested}
                                                            onClick={() => toggleSecondT(top, second)}
                                                            aria-expanded={secondOpen}
                                                            style={{
                                                                background: secondOpen ? "#3c55e6" : "rgba(26,42,128,0.15)",
                                                                borderRadius: secondOpen ? 8 : 0,
                                                                marginTop: 2,
                                                            }}
                                                        >
                                                            <ListItemIcon style={{ color: secondOpen ? "#fff" : "inherit" }}>
                                                                {iconFor(second)}
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                primary={second.title}
                                                                primaryTypographyProps={{
                                                                    style: { fontWeight: secondOpen ? "bold" : "normal", color: secondOpen ? "#fff" : "inherit" },
                                                                }}
                                                            />
                                                            {secondOpen ? <ExpandLess aria-hidden="true" style={{ color: "#fff" }} /> : <ExpandMore aria-hidden="true" />}
                                                        </ListItem>

                                                        <Collapse in={secondOpen} timeout="auto" unmountOnExit>
                                                            <List disablePadding>
                                                                {(second.children || []).map((third) => {
                                                                    const skey = sk;
                                                                    const tk3 = third.slug || third.id || third.title;
                                                                    const thirdOpen = !!(openThirdT[skey]?.[tk3]);
                                                                    return (
                                                                        <React.Fragment key={tk3}>
                                                                            <ListItem
                                                                                button
                                                                                className={classes.nested2}
                                                                                onClick={() => toggleThirdT(second, third)}
                                                                                aria-expanded={thirdOpen}
                                                                                style={{
                                                                                    background: thirdOpen ? "#B2B0E8" : "whitesmoke",
                                                                                    borderRadius: thirdOpen ? 8 : 0,
                                                                                    marginTop: 2,
                                                                                }}
                                                                            >
                                                                                <ListItemIcon style={{ color: thirdOpen ? "#fff" : "inherit" }}>
                                                                                    {iconFor(third)}
                                                                                </ListItemIcon>
                                                                                <ListItemText
                                                                                    primary={third.title}
                                                                                    primaryTypographyProps={{
                                                                                        style: { fontWeight: thirdOpen ? "bold" : "normal", color: thirdOpen ? "#fff" : "inherit" },
                                                                                    }}
                                                                                />
                                                                                {thirdOpen ? <ExpandLess aria-hidden="true" style={{ color: "#fff" }} /> : <ExpandMore aria-hidden="true" />}
                                                                            </ListItem>

                                                                            <Collapse in={thirdOpen} timeout="auto" unmountOnExit>
                                                                                <Box px={4} pb={2} pt={2}>
                                                                                    <Grid container spacing={2} wrap="wrap" justifyContent="space-evenly">
                                                                                        {(third.topics || []).map((t) => (
                                                                                            <Grid item key={t.id || t.title} className={classes.gridItem}>
                                                                                                <Card
                                                                                                    className={classes.card}
                                                                                                    style={{ borderRadius: 8, border: "1px solid rgba(0,0,0,0.08)", boxShadow: "none", background: "whitesmoke" }}
                                                                                                >
                                                                                                    <CardContent>
                                                                                                        <Typography
                                                                                                            variant="h1"
                                                                                                            className={classes.cardHeader}
                                                                                                        >
                                                                                                            {t.template_section_label || t.title}
                                                                                                        </Typography>
                                                                                                        <hr style={{ width: "100%", borderColor: "rgba(0,0,0,0.1)" }} />
                                                                                                    </CardContent>
                                                                                                    <CardActions>
                                                                                                        <Button
                                                                                                            className={classes.cardButton}
                                                                                                            onClick={() => setOpenTopic({ ...t, path: [top.title, second.title, third.title] })}
                                                                                                        >
                                                                                                            View Template
                                                                                                        </Button>
                                                                                                    </CardActions>
                                                                                                </Card>
                                                                                            </Grid>
                                                                                        ))}
                                                                                    </Grid>
                                                                                </Box>
                                                                            </Collapse>
                                                                        </React.Fragment>
                                                                    );
                                                                })}

                                                                {(second.topics || []).length > 0 && (
                                                                    <Box px={4} pb={2} pt={2}>
                                                                        <Grid container spacing={2} wrap="wrap" justifyContent="space-evenly">
                                                                            {(second.topics || []).map((t) => (
                                                                                <Grid item key={t.id || t.title} className={classes.gridItem}>
                                                                                    <Card
                                                                                        className={classes.card}
                                                                                        style={{ borderRadius: 8, border: "1px solid rgba(0,0,0,0.08)", boxShadow: "none", background: "whitesmoke" }}
                                                                                    >
                                                                                        <CardContent>
                                                                                            <Typography variant="h1" className={classes.cardHeader}>
                                                                                                {t.template_section_label || t.title}
                                                                                            </Typography>
                                                                                            <hr style={{ width: "100%", borderColor: "rgba(0,0,0,0.1)" }} />
                                                                                        </CardContent>
                                                                                        <CardActions>
                                                                                            <Button
                                                                                                className={classes.cardButton}
                                                                                                onClick={() => setOpenTopic({ ...t, path: [top.title, second.title] })}
                                                                                            >
                                                                                                View Template
                                                                                            </Button>
                                                                                        </CardActions>
                                                                                    </Card>
                                                                                </Grid>
                                                                            ))}
                                                                        </Grid>
                                                                    </Box>
                                                                )}
                                                            </List>
                                                        </Collapse>
                                                    </React.Fragment>
                                                );
                                            })}

                                            {(top.topics || []).length > 0 && (
                                                <Box px={4} pb={2} pt={2}>
                                                    <Grid container spacing={2} wrap="wrap" justifyContent="space-evenly">
                                                        {(top.topics || []).map((t) => (
                                                            <Grid item key={t.id || t.title} className={classes.gridItem}>
                                                                <Card
                                                                    className={classes.card}
                                                                    style={{ borderRadius: 8, border: "1px solid rgba(0,0,0,0.08)", boxShadow: "none", background: "whitesmoke" }}
                                                                >
                                                                    <CardContent>
                                                                        <Typography variant="h1" className={classes.cardHeader}>
                                                                            {t.template_section_label || t.title}
                                                                        </Typography>
                                                                        <hr style={{ width: "100%", borderColor: "rgba(0,0,0,0.1)" }} />
                                                                    </CardContent>
                                                                    <CardActions>
                                                                        <Button
                                                                            className={classes.cardButton}
                                                                            onClick={() => setOpenTopic({ ...t, path: [top.title] })}
                                                                        >
                                                                            View Template
                                                                        </Button>
                                                                    </CardActions>
                                                                </Card>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </Box>
                                            )}
                                        </List>
                                    </Collapse>
                                    <Divider />
                                </React.Fragment>
                            );
                        })}
                    </List>
                </Box>
                {/* )} */}

                <Dialog
                    open={Boolean(openTopic)}
                    onClose={() => setOpenTopic(null)}
                    fullWidth
                    maxWidth="sm"
                    aria-labelledby="topic-dialog-title"
                >

                    <DialogTitle id="topic-dialog-title">
                        {openTopic?.title}
                    </DialogTitle>

                    <DialogContent
                        dividers
                    >

                        <Typography
                            variant="body2"
                            // color="textSecondary"
                            gutterBottom
                        >
                            {openTopic ? ["Help Center", ...(openTopic.path || [])].join(" › ") : ""}
                        </Typography>

                        {openTopic?.is_template ? (
                            <Box
                                mt={1}
                                mb={1}
                                p={2}
                                style={{
                                    background: "#f0f2fa",
                                    borderRadius: 8,
                                    border: "1px solid rgba(26,42,128,0.15)",
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    style={{ whiteSpace: "pre-wrap" }}
                                >
                                    {openTopic.body_md || openTopic.template_section_label || "No description provided."}
                                </Typography>
                            </Box>
                        ) : openTopic?.video_url ? (
                            <div className={classes.video}>
                                <video
                                    controls
                                    title={openTopic?.title || "Help video"}
                                    aria-label={openTopic?.title || "Help video"}
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: 8,
                                    }}
                                >
                                    <source src={openTopic.video_url} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        ) : (
                            <div className={classes.video}>
                                <Typography className={classes.videoLabel}>Video placeholder</Typography>
                            </div>
                        )}
                        <Box mt={2}>
                            <Typography
                                variant="h3"
                                style={{
                                    display: "inline-block",
                                    fontSize: 14,
                                    fontWeight: "bold",
                                    marginBottom: 8,
                                }}
                            >
                                {openTopic?.is_template ? "Template File" : "Document"}
                            </Typography>
                            {openTopic?.document ? (
                                <Box mt={1}>
                                    <Button
                                        variant="outlined"
                                        component="a"
                                        href={openTopic.document}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {openTopic?.is_template ? "Download template" : "Open attached document"}
                                    </Button>
                                </Box>
                            ) : openTopic?.body_md ? (
                                <Box mt={1}>
                                    <Typography component="pre" style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                                        {openTopic.body_md}
                                    </Typography>
                                </Box>
                            ) : (
                                <Typography color="textSecondary">
                                    Placeholder document content. Will be replaced with actual help content in future.
                                </Typography>
                            )}
                        </Box>

                        {openTopic?.tags?.length ? (
                            <Box
                                mt={2}
                                className={classes.chips}
                            >
                                {openTopic.tags.map((tag) => (
                                    <Chip
                                        key={tag}
                                        size="small"
                                        label={`#${tag}`}
                                        className={classes.cardChips}
                                    />
                                ))}
                            </Box>
                        ) : null}
                    </DialogContent>

                    <DialogActions>

                        <Button
                            onClick={() => setOpenTopic(null)}
                        // color="primary"
                        >
                            Close
                        </Button>

                    </DialogActions>
                </Dialog>
            </Box>
        </>
    );
}

const pickUser = (state) => {
    const candidates = [
        state.auth && state.auth.user,
        state.authState && state.authState.user,
        state.nav && state.nav.user,
        state.sync && state.sync.user,
        state.users && (state.users.current || state.users.user || state.users.me),
    ];
    return candidates.find(Boolean) || null;
};

const normTruthy = (v) => {
    if (v == null) return false;
    if (typeof v === "string") return ["true", "1", "yes", "y"].includes(v.trim().toLowerCase());
    if (typeof v === "number") return v === 1;
    return !!v;
};


const mapStateToProps = (state) => {
    const user = pickUser(state);
    return { user };
};



export default connect(mapStateToProps)(HelpCenter);